import { useQuery } from '@tanstack/react-query';
import { lookupsApi } from '../../api/endpoints/lookups';

/**
 * Mapa value→label de las etapas de venta, leído del catálogo editable
 * (`sale_stage`). Reemplaza al antiguo STAGE_LABEL hardcoded.
 */
export function useSaleStageLabels(): Record<string, string> {
  const { data } = useQuery({
    queryKey: ['lookups', 'sale_stage'],
    queryFn: () => lookupsApi.byList('sale_stage'),
    staleTime: 5 * 60_000,
  });
  return Object.fromEntries((data ?? []).map((l) => [l.value, l.label]));
}
